import React from 'react'
import PropTypes from 'prop-types'

const UsersPlusCircleIcon = (props) => {
  const {
    color1 = '#000000',
    color2 = '#000000',
    bgColor = '#FFFFFF',
    classes = 'w-20',
  } = props
  return (
    <svg
      width="110"
      height="110"
      viewBox="0 0 110 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <g clipPath="url(#clip0_9846_28596)">
        <circle cx="55.0317" cy="55.166" r="54.5337" fill={bgColor} />
        <path
          d="M93.4415 48.8328C93.4415 48.1269 92.8685 47.5539 92.1625 47.5539H88.3869V43.7782C88.3869 43.0723 87.8139 42.4993 87.1079 42.4993C86.402 42.4993 85.829 43.0723 85.829 43.7782V47.5539H82.0534C81.3461 47.5539 80.7744 48.1269 80.7744 48.8328C80.7744 49.5401 81.3461 50.1117 82.0534 50.1117H85.829V53.8874C85.829 54.5933 86.402 55.1663 87.1079 55.1663C87.8139 55.1663 88.3869 54.5933 88.3869 53.8874V50.1117H92.1625C92.8685 50.1131 93.4415 49.5401 93.4415 48.8328Z"
          fill={color1}
        />
        <path
          d="M47.497 64.8776C46.8296 58.915 41.7883 54.4068 35.7885 54.4068H28.6227C22.6229 54.4068 17.5816 58.915 16.9142 64.8776L16.623 67.4674C28.1228 70.8601 38.5112 70.8601 47.7855 67.4674L47.497 64.8776ZM32.2056 51.6495C36.7789 51.6495 40.4868 47.9417 40.4868 43.3683C40.4868 38.795 36.7789 35.0872 32.2056 35.0872C27.6323 35.0872 23.9244 38.795 23.9244 43.3683C23.9258 47.9417 27.6336 51.6495 32.2056 51.6495Z"
          fill={color2}
        />
        <path
          d="M84.2568 64.8776C83.5894 58.915 78.5481 54.4068 72.5483 54.4068H65.3825C59.3826 54.4068 54.3414 58.915 53.674 64.8776L53.3828 67.4674C64.8826 70.8601 75.271 70.8601 84.5452 67.4674L84.2568 64.8776ZM68.9654 51.6495C73.5387 51.6495 77.2466 47.9417 77.2466 43.3683C77.2466 38.795 73.5387 35.0872 68.9654 35.0872C64.392 35.0872 60.6842 38.795 60.6842 43.3683C60.6855 47.9417 64.3934 51.6495 68.9654 51.6495Z"
          fill={color2}
        />
        <path
          d="M69.5092 70.4229C68.6833 63.0438 62.4443 57.4647 55.0192 57.4647H46.1511C38.7259 57.4647 32.4871 63.0438 31.6611 70.4229L31.3008 73.6279C45.5325 77.8267 58.3887 77.8267 69.8662 73.6279L69.5092 70.4229ZM50.5851 54.0523C56.2449 54.0523 60.8336 49.4636 60.8336 43.8039C60.8336 38.1441 56.2449 33.5554 50.5851 33.5554C44.9254 33.5554 40.3367 38.1441 40.3367 43.8039C40.3383 49.4636 44.927 54.0523 50.5851 54.0523Z"
          fill={color1}
        />
      </g>
      <defs>
        <clipPath id="clip0_9846_28596">
          <rect
            width="109.067"
            height="109.067"
            fill="white"
            transform="translate(0.498047 0.632324)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

UsersPlusCircleIcon.propTypes = {
  color1: PropTypes.string,
  color2: PropTypes.string,
  bgColor: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(UsersPlusCircleIcon)
